/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoardCardViewDetails = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m10.5 3 6.043.002.085.015.063.02.076.04.055.04.06.06.03.038.041.074.03.083.015.082L17 3.5v6a.5.5 0 0 1-.992.09L16 9.5V4.706L4.706 16H9.5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L9.5 17H3.48l-.069-.008-.102-.03-.076-.04-.055-.04-.06-.06-.03-.037-.041-.074-.03-.083-.006-.023A.499.499 0 0 1 3 16.5l.005.074-.003-.031L3 10.5a.5.5 0 0 1 .992-.09L4 10.5v4.792L15.292 4H10.5a.5.5 0 0 1-.492-.41L10 3.5a.5.5 0 0 1 .5-.5Z"
    }));
export default SvgBoardCardViewDetails;
